import request from '@/utils/request'
import { arrayToFormDataToSave } from '@/utils/file.js'

// 조회
export function getEmergencyResponseManual(param, isNotify) {
  return request({
    url: '/api/getEmergencyResponseManual',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}
// 디테일 조회
export function getEmergencyResponseManualDetail(param, isNotify) {
  return request({
    url: '/api/getEmergencyResponseManualDetail',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}

// 저장
export function saveEmergencyResponseManual (param, isNotify) {
  const formData = arrayToFormDataToSave(param)
  return request({
    url: '/api/saveEmergencyResponseManual',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: formData,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}

//삭제
export function deleteEmergencyResponseManual (param, isNotify) {
  return request({
    url: '/api/deleteEmergencyResponseManual',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}